import type { ReactNode } from 'react';
import { StatusBadge } from './ui.js';
import type { IconName, Tone } from './ui.js';

const TONE_ICON: Record<Tone, IconName> = {
  ok: 'check',
  warn: 'alert',
  bad: 'alert',
  neu: 'info',
  acc: 'info',
  sim: 'flask',
};

/** Stav ikonou a textem; ikona se vybere podle tónu (nikdy jen barva). */
export function ToneBadge({ tone, children }: { tone: Tone; children: ReactNode }): JSX.Element {
  return (
    <StatusBadge tone={tone} icon={TONE_ICON[tone]}>
      {children}
    </StatusBadge>
  );
}
